export default [
  {
    name: 'Bohemian Design Ideas',
    slug: 'bohemian-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bohemian-design-ideas.jpeg',
    group: 1,
    shortName: 'Bohemian',
    styleNav: 2,
  },
  {
    name: 'Classic Design Ideas',
    slug: 'classic-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/classic-design-ideas.jpeg',
    group: 1,
    shortName: 'Classic',
    styleNav: 3,
  },
  {
    name: 'Coastal Design Ideas',
    slug: 'coastal-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/coastal-design-ideas.jpeg',
    group: 1,
    shortName: 'Coastal',
    styleNav: 5,
  },
  {
    name: 'Eclectic Design Ideas',
    slug: 'eclectic-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/eclectic-design-ideas.jpeg',
    group: 2,
    shortName: 'Eclectic',
  },
  {
    name: 'Farmhouse Design Ideas',
    slug: 'farmhouse-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/farmhouse-design-ideas.jpeg',
    group: 2,
    shortName: 'Farmhouse',
  },
  {
    name: 'Glam Design Ideas',
    slug: 'glam-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/glam-design-ideas.jpeg',
    group: 2,
    shortName: 'Glam',
  },
  {
    name: 'Industrial Design Ideas',
    slug: 'industrial-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/industrial-design-ideas.jpeg',
    group: 3,
    shortName: 'Industrial',
    styleNav: 4,
  },
  {
    name: 'Mid-Mod Design Ideas',
    slug: 'midcentury-modern-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/midcentury-modern-design-ideas.jpeg',
    group: 3,
    shortName: 'Mid-Mod',
    styleNav: 1,
  },
  {
    name: 'Modern Design Ideas',
    slug: 'modern-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/modern-design-ideas.jpeg',
    group: 3,
    shortName: 'Modern',
  },
  {
    name: 'Preppy Design Ideas',
    slug: 'preppy-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/preppy-design-ideas.jpeg',
    group: 4,
    shortName: 'Preppy',
  },
  {
    name: 'Rustic Design Ideas',
    slug: 'rustic-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/rustic-design-ideas.jpeg',
    group: 4,
    shortName: 'Rustic',
  },
  {
    name: 'Scandinavian Design Ideas',
    slug: 'scandinavian-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/scandinavian-design-ideas.jpeg',
    group: 4,
    shortName: 'Scandinavian',
    styleNav: 0,
  },
  {
    name: 'Traditional Design Ideas',
    slug: 'traditional-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/traditional-design-ideas.jpeg',
    group: 5,
    shortName: 'Traditional',
  },
  {
    name: 'Transitional Design Ideas',
    slug: 'transitional-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/transitional-design-ideas.jpeg',
    group: 5,
    shortName: 'Transitional',
  },
  {
    name: 'Bedroom Design Ideas',
    slug: 'bedroom-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bedroom-design-ideas.jpeg',
    group: 5,
    shortName: 'Bedroom',
    roomNav: 0,
  },
  {
    name: 'Dining Room Design Ideas',
    slug: 'dining-room-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/dining-room-design-ideas.jpeg',
    group: 6,
    shortName: 'Dining Room',
    roomNav: 1,
  },
  {
    name: 'Living Room Design Ideas',
    slug: 'living-room-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/living-room-design-ideas.jpeg',
    group: 6,
    shortName: 'Living Room',
    roomNav: 2,
  },
  {
    name: 'Nursery Design Ideas',
    slug: 'nursery-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/nursery-design-ideas.jpeg',
    group: 6,
    shortName: 'Nursery',
    roomNav: 3,
  },
  {
    name: 'Office Design Ideas',
    slug: 'office-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/office-design-ideas.jpeg',
    group: 7,
    shortName: 'Office',
    roomNav: 4,
  },
  {
    name: 'Patio',
    slug: 'patio-design-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/other-design-ideas.jpeg',
    group: 7,
    shortName: 'Patio',
    omitFromFeed: true,
    roomNav: 5,
  },
  {
    name: 'Bohemian Bedroom Ideas',
    slug: 'bohemian-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bohemian-bedroom-ideas.jpeg',
    group: 7,
    shortName: 'Bohemian Bedroom',
  },
  {
    name: 'Classic Bedroom Ideas',
    slug: 'classic-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/classic-bedroom-ideas.jpeg',
    group: 7,
    shortName: 'Classic Bedroom',
  },
  {
    name: 'Coastal Bedroom Ideas',
    slug: 'coastal-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/coastal-bedroom-ideas.jpeg',
    group: 8,
    shortName: 'Coastal Bedroom',
  },
  {
    name: 'Eclectic Bedroom Ideas',
    slug: 'eclectic-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/eclectic-bedroom-ideas.jpeg',
    group: 8,
    shortName: 'Eclectic Bedroom',
  },
  {
    name: 'Farmhouse Bedroom Ideas',
    slug: 'farmhouse-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/farmhouse-bedroom-ideas.jpeg',
    group: 8,
    shortName: 'Farmhouse Bedroom',
  },
  {
    name: 'Glam Bedroom Ideas',
    slug: 'glam-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/glam-bedroom-ideas.jpeg',
    group: 9,
    shortName: 'Glam Bedroom',
  },
  {
    name: 'Industrial Bedroom Ideas',
    slug: 'industrial-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/industrial-bedroom-ideas.jpeg',
    group: 9,
    shortName: 'Industrial Bedroom',
  },
  {
    name: 'Mid-Mod Bedroom Ideas',
    slug: 'midcentury-modern-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/midcentury-modern-bedroom-ideas.jpeg',
    group: 9,
    shortName: 'Mid-Mod Bedroom',
  },
  {
    name: 'Modern Bedroom Ideas',
    slug: 'modern-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/modern-bedroom-ideas.jpeg',
    group: 10,
    shortName: 'Modern Bedroom',
  },
  {
    name: 'Preppy Bedroom Ideas',
    slug: 'preppy-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/preppy-bedroom-ideas.jpeg',
    group: 10,
    shortName: 'Preppy Bedroom',
  },
  {
    name: 'Rustic Bedroom Ideas',
    slug: 'rustic-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/rustic-bedroom-ideas.jpeg',
    group: 10,
    shortName: 'Rustic Bedroom',
  },
  {
    name: 'Scandinavian Bedroom Ideas',
    slug: 'scandinavian-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/scandinavian-bedroom-ideas.jpeg',
    group: 11,
    shortName: 'Scandinavian Bedroom',
  },
  {
    name: 'Traditional Bedroom Ideas',
    slug: 'traditional-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/traditional-bedroom-ideas.jpeg',
    group: 11,
    shortName: 'Traditional Bedroom',
  },
  {
    name: 'Transitional Bedroom Ideas',
    slug: 'transitional-bedroom-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/transitional-bedroom-ideas.jpeg',
    group: 11,
    shortName: 'Transitional Bedroom',
  },
  {
    name: 'Bohemian Dining Room Ideas',
    slug: 'bohemian-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bohemian-dining-room-ideas.jpeg',
    group: 12,
    shortName: 'Bohemian Dining Room',
  },
  {
    name: 'Classic Dining Room Ideas',
    slug: 'classic-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/classic-dining-room-ideas.jpeg',
    group: 12,
    shortName: 'Classic Dining Room',
  },
  {
    name: 'Coastal Dining Room Ideas',
    slug: 'coastal-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/coastal-dining-room-ideas.jpeg',
    group: 12,
    shortName: 'Coastal Dining Room',
  },
  {
    name: 'Eclectic Dining Room Ideas',
    slug: 'eclectic-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/eclectic-dining-room-ideas.jpeg',
    group: 13,
    shortName: 'Eclectic Dining Room',
  },
  {
    name: 'Farmhouse Dining Room Ideas',
    slug: 'farmhouse-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/farmhouse-dining-room-ideas.jpeg',
    group: 13,
    shortName: 'Farmhouse Dining Room',
  },
  {
    name: 'Glam Dining Room Ideas',
    slug: 'glam-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/glam-dining-room-ideas.jpeg',
    group: 13,
    shortName: 'Glam Dining Room',
  },
  {
    name: 'Industrial Dining Room Ideas',
    slug: 'industrial-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/industrial-dining-room-ideas.jpeg',
    group: 14,
    shortName: 'Industrial Dining Room',
  },
  {
    name: 'Mid-Mod Dining Room Ideas',
    slug: 'midcentury-modern-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/midcentury-modern-dining-room-ideas.jpeg',
    group: 14,
    shortName: 'Mid-Mod Dining Room',
  },
  {
    name: 'Modern Dining Room Ideas',
    slug: 'modern-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/modern-dining-room-ideas.jpeg',
    group: 14,
    shortName: 'Modern Dining Room',
  },
  {
    name: 'Preppy Dining Room Ideas',
    slug: 'preppy-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/preppy-dining-room-ideas.jpeg',
    group: 15,
    shortName: 'Preppy Dining Room',
  },
  {
    name: 'Rustic Dining Room Ideas',
    slug: 'rustic-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/rustic-dining-room-ideas.jpeg',
    group: 15,
    shortName: 'Rustic Dining Room',
  },
  {
    name: 'Scandinavian Dining Room Ideas',
    slug: 'scandinavian-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/scandinavian-dining-room-ideas.jpeg',
    group: 15,
    shortName: 'Scandinavian Dining Room',
  },
  {
    name: 'Traditional Dining Room Ideas',
    slug: 'traditional-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/traditional-dining-room-ideas.jpeg',
    group: 16,
    shortName: 'Traditional Dining Room',
  },
  {
    name: 'Transitional Dining Room Ideas',
    slug: 'transitional-dining-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/transitional-dining-room-ideas.jpeg',
    group: 16,
    shortName: 'Transitional Dining Room',
  },
  {
    name: 'Bohemian Living Room Ideas',
    slug: 'bohemian-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bohemian-living-room-ideas.jpeg',
    group: 16,
    shortName: 'Bohemian Living Room',
  },
  {
    name: 'Classic Living Room Ideas',
    slug: 'classic-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/classic-living-room-ideas.jpeg',
    group: 17,
    shortName: 'Classic Living Room',
  },
  {
    name: 'Coastal Living Room Ideas',
    slug: 'coastal-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/coastal-living-room-ideas.jpeg',
    group: 17,
    shortName: 'Coastal Living Room',
  },
  {
    name: 'Eclectic Living Room Ideas',
    slug: 'eclectic-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/eclectic-living-room-ideas.jpeg',
    group: 17,
    shortName: 'Eclectic Living Room',
  },
  {
    name: 'Farmhouse Living Room Ideas',
    slug: 'farmhouse-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/farmhouse-living-room-ideas.jpeg',
    group: 18,
    shortName: 'Farmhouse Living Room',
  },
  {
    name: 'Glam Living Room Ideas',
    slug: 'glam-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/glam-living-room-ideas.jpeg',
    group: 18,
    shortName: 'Glam Living Room',
  },
  {
    name: 'Industrial Living Room Ideas',
    slug: 'industrial-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/industrial-living-room-ideas.jpeg',
    group: 18,
    shortName: 'Industrial Living Room',
  },
  {
    name: 'Mid-Mod Living Room Ideas',
    slug: 'midcentury-modern-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/midcentury-modern-living-room-ideas.jpeg',
    group: 19,
    shortName: 'Mid-Mod Living Room',
  },
  {
    name: 'Modern Living Room Ideas',
    slug: 'modern-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/modern-living-room-ideas.jpeg',
    group: 19,
    shortName: 'Modern Living Room',
  },
  {
    name: 'Preppy Living Room Ideas',
    slug: 'preppy-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/preppy-living-room-ideas.jpeg',
    group: 19,
    shortName: 'Preppy Living Room',
  },
  {
    name: 'Rustic Living Room Ideas',
    slug: 'rustic-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/rustic-living-room-ideas.jpeg',
    group: 20,
    shortName: 'Rustic Living Room',
  },
  {
    name: 'Scandinavian Living Room Ideas',
    slug: 'scandinavian-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/scandinavian-living-room-ideas.jpeg',
    group: 20,
    shortName: 'Scandinavian Living Room',
  },
  {
    name: 'Traditional Living Room Ideas',
    slug: 'traditional-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/traditional-living-room-ideas.jpeg',
    group: 20,
    shortName: 'Traditional Living Room',
  },
  {
    name: 'Transitional Living Room Ideas',
    slug: 'transitional-living-room-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/transitional-living-room-ideas.jpeg',
    group: 21,
    shortName: 'Transitional Living Room',
  },
  {
    name: 'Bohemian Nursery Ideas',
    slug: 'bohemian-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bohemian-nursery-ideas.jpeg',
    group: 21,
    shortName: 'Bohemian Nursery',
  },
  {
    name: 'Classic Nursery Ideas',
    slug: 'classic-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/classic-nursery-ideas.jpeg',
    group: 21,
    shortName: 'Classic Nursery',
  },
  {
    name: 'Coastal Nursery Ideas',
    slug: 'coastal-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/coastal-nursery-ideas.jpeg',
    group: 22,
    shortName: 'Coastal Nursery',
  },
  {
    name: 'Eclectic Nursery Ideas',
    slug: 'eclectic-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/eclectic-nursery-ideas.jpeg',
    group: 22,
    shortName: 'Eclectic Nursery',
  },
  {
    name: 'Farmhouse Nursery Ideas',
    slug: 'farmhouse-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/farmhouse-nursery-ideas.jpeg',
    group: 22,
    shortName: 'Farmhouse Nursery',
  },
  {
    name: 'Glam Nursery Ideas',
    slug: 'glam-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/glam-nursery-ideas.jpeg',
    group: 23,
    shortName: 'Glam Nursery',
  },
  {
    name: 'Industrial Nursery Ideas',
    slug: 'industrial-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/industrial-nursery-ideas.jpeg',
    group: 23,
    shortName: 'Industrial Nursery',
  },
  {
    name: 'Mid-Mod Nursery Ideas',
    slug: 'midcentury-modern-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/midcentury-modern-nursery-ideas.jpeg',
    group: 23,
    shortName: 'Mid-Mod Nursery',
  },
  {
    name: 'Modern Nursery Ideas',
    slug: 'modern-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/modern-nursery-ideas.jpeg',
    group: 24,
    shortName: 'Modern Nursery',
  },
  {
    name: 'Preppy Nursery Ideas',
    slug: 'preppy-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/preppy-nursery-ideas.jpeg',
    group: 24,
    shortName: 'Preppy Nursery',
  },
  {
    name: 'Rustic Nursery Ideas',
    slug: 'rustic-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/rustic-nursery-ideas.jpeg',
    group: 24,
    shortName: 'Rustic Nursery',
  },
  {
    name: 'Scandinavian Nursery Ideas',
    slug: 'scandinavian-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/scandinavian-nursery-ideas.jpeg',
    group: 25,
    shortName: 'Scandinavian Nursery',
  },
  {
    name: 'Traditional Nursery Ideas',
    slug: 'traditional-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/traditional-nursery-ideas.jpeg',
    group: 25,
    shortName: 'Traditional Nursery',
  },
  {
    name: 'Transitional Nursery Ideas',
    slug: 'transitional-nursery-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/transitional-nursery-ideas.jpeg',
    group: 25,
    shortName: 'Transitional Nursery',
  },
  {
    name: 'Bohemian Office Ideas',
    slug: 'bohemian-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/bohemian-office-ideas.jpeg',
    group: 26,
    shortName: 'Bohemian Office',
  },
  {
    name: 'Classic Office Ideas',
    slug: 'classic-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/classic-office-ideas.jpeg',
    group: 26,
    shortName: 'Classic Office',
  },
  {
    name: 'Coastal Office Ideas',
    slug: 'coastal-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/coastal-office-ideas.jpeg',
    group: 26,
    shortName: 'Coastal Office',
  },
  {
    name: 'Eclectic Office Ideas',
    slug: 'eclectic-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/eclectic-office-ideas.jpeg',
    group: 27,
    shortName: 'Eclectic Office',
  },
  {
    name: 'Farmhouse Office Ideas',
    slug: 'farmhouse-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/farmhouse-office-ideas.jpeg',
    group: 27,
    shortName: 'Farmhouse Office',
  },
  {
    name: 'Glam Office Ideas',
    slug: 'glam-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/glam-office-ideas.jpeg',
    group: 27,
    shortName: 'Glam Office',
  },
  {
    name: 'Industrial Office Ideas',
    slug: 'industrial-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/industrial-office-ideas.jpeg',
    group: 28,
    shortName: 'Industrial Office',
  },
  {
    name: 'Mid-Mod Office Ideas',
    slug: 'midcentury-modern-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/midcentury-modern-office-ideas.jpeg',
    group: 28,
    shortName: 'Mid-Mod Office',
  },
  {
    name: 'Modern Office Ideas',
    slug: 'modern-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/modern-office-ideas.jpeg',
    group: 28,
    shortName: 'Modern Office',
  },
  {
    name: 'Preppy Office Ideas',
    slug: 'preppy-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/preppy-office-ideas.jpeg',
    group: 29,
    shortName: 'Preppy Office',
  },
  {
    name: 'Rustic Office Ideas',
    slug: 'rustic-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/rustic-office-ideas.jpeg',
    group: 29,
    shortName: 'Rustic Office',
  },
  {
    name: 'Scandinavian Office Ideas',
    slug: 'scandinavian-office-ideas',
    imageUrl: 'https://s3.amazonaws.com/static.havenly.com/explore/discover_pages/scandinavian-office-ideas.jpeg',
    group: 29,
    shortName: 'Scandinavian Office',
  },
];
